import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";

import LeadAPI from "../../api/LeadAPI";
import ContactAPI from "../../api/ContactAPI";
import withRouter from "../../util/WithRouter";
import Util from "../../util/Util";
import LeadConst from "../../util/LeadConst";
import Const from "../../util/Constants";
import Display from "../../util/Display";
import ApiUiController from "../../controller/ApiUiController";
import LeadPreviewPopUpList from "./LeadPreviewPopUpList";
import LeadPreviewActionList from "./LeadPreviewActionList";
import TabPanelView from "../common/TabPanelView";
import PropertyConst from "../../util/PropertyConst";
import StatusProgressBar from "./StatusProgressBar.js";
import "./LeadPreview.css";
import LeadScore from "./LeadScore.js";
import RestrictedAccess from "../RestrictedAccess.js";

class LeadPreviewCompact extends React.Component {
  constructor(props) {
    super(props);

    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.lead;
    this.ProgressOptions = this.model.fields.progress.options;
    this.id = parseInt(props.match.params.leadId);
    this.options = [{ label: 'Tab View', value: 1 }, { label: 'List View', value: 2 }, { label: 'Compact', value: 3 }];
    this.isGrowthPackageAndAbove = this.user?.package >= Const.PackageGrowth;
    if(this.isGrowthPackageAndAbove) {
      this.options.push({ label: 'Mordern View', value: LeadConst.ModernView })
    }
    const query = new URLSearchParams(props.location.search);
    this.iItem = query.get("indx") ? parseInt(query.get("indx")) : 0;
    this.lItem = query.get("size") ? parseInt(query.get("size")) : 0;
    const isNext = this.iItem !== 0 && this.lItem !== 0;

    this.isEnterprise = this.user.package === Const.PackageEnterprise;
    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.indexOf("/preview"));
    this.editLink = `${this.base}/add-edit/${this.id}${isNext ? `?indx=${this.iItem}&size=${this.lItem}` : ""}`;

    this.state = {
      inApiCall: this.id !== 0,
      popup: null,
      call: null,
      task: null,
      ticket: null,
      meeting: null,
      document: null,
      note: null,
      email: 0,
      sms: 0,
      whatsApp: 0,
      contacts: [],
      change: false,
      propertyCount: 0
    };
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.CallAdd = Util.isAllow(this.models.call.permission, Const.PermAdd);
    this.CallUpdate = Util.isAllow(this.models.call.permission, Const.PermUpdate);
    this.MeetAdd = Util.isAllow(this.models.meeting.permission, Const.PermAdd);
    this.Property = Util.isAllow(this.models.property.permission, Const.PermView);
    this.MeetUpdate = Util.isAllow(this.models.meeting.permission, Const.PermUpdate);
    this.DocAdd = Util.isAllow(this.models.document.permission, Const.PermAdd);
    this.SmsAdd = Util.isAllow(this.models.sms.permission, Const.PermAdd);

    this.whatsAppAdd = Util.isAllow(this.models.whatsapp.permission, Const.PermAdd);
    this.NoteAdd = Util.isAllow(this.models.note.permission, Const.PermAdd);
    this.EmailAdd = Util.isAllow(this.models.email.permission, Const.PermAdd);
    this.SalesAdd = Util.isAllow(this.models.sales_order.permission, Const.PermAdd);
    this.ContactAdd = Util.isAllow(this.models.contact.permission, Const.PermAdd);
    this.CloudCall = reactLocalStorage.getObject(Const.CloudCalling);
    this.CloudCall = this.CloudCall && Object.keys(this.CloudCall).length > 0 ? this.CloudCall : null;
    this.HidePhone = Util.isAllow(this.model.permission, Const.HideAllPhone);
    this.LeadPreviewRestrict = Util.isAllow(this.model.permission, Const.PermLeadPreviewRestrict);
    // function for matching properies
    this.onProperties = () => {
      const lead = this.lead;
      const filter = [];
      const fields = this.models.property.fields;
      const SearchProperty = ['price', 'property_transaction', 'property_is', 'property_type', 'area'];
      for (let i = 0; i < SearchProperty.length; i++) {
        const field = SearchProperty[i];
        if (!fields[field]) {
          continue;
        }
        const type = fields[field].field_type;
        if (type === Const.Number || type === Const.Decimal) {
          if (field === PropertyConst.Price) {
            if (lead.min_budget && lead.max_budget) {
              filter.push({
                field,
                type,
                condition: "in",
                value: `${lead.min_budget}~${lead.max_budget}`,
              });
            } else if (lead.min_budget) {
              filter.push({
                field,
                type,
                condition: "start-with",
                value: `${lead.min_budget}~`,
              });
            } else if (lead.max_budget) {
              filter.push({
                field,
                type,
                condition: "end-with",
                value: `~${lead.max_budget}`,
              });
            }
          } else if (lead[field]) {
            filter.push({
              field,
              type,
              condition: "start-with",
              value: `${lead[field]}~`,
            });
          }
        } else if (type.includes(Const.Select) && lead[field]) {
          const value =
            typeof lead[field] === "string" && lead[field].includes(Const.Opt)
              ? lead[field]
              : `~${lead[field]}~`;
          filter.push({ field, type, condition: "in", value });
        }
      }
      this.props.navigate(`/property?filters=${JSON.stringify(filter)}`);
    };

    const LeadTheam = reactLocalStorage.get(Const.LeadTheme)
      ? parseInt(reactLocalStorage.get(Const.LeadTheme))
      : Const.LeadTheme;
    this.designOption = this.options.find(
      (opt) => opt.value === LeadTheam
    );

  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.id !== parseInt(props.match.params.leadId)) {
      this.id = parseInt(props.match.params.leadId);
      let dummy = { ...this.state };
      if (dummy.call) {
        dummy.call.model_no = Const.Lead;
        dummy.call.model_id = this.id;
      }
      if (dummy.task) {
        dummy.task.model_no = Const.Lead;
        dummy.task.model_id = this.id;
      }
      if (dummy.ticket) {
        dummy.ticket.model_no = Const.Lead;
        dummy.ticket.model_id = this.id;
      }
      if (dummy.meeting) {
        dummy.meeting.model_no = Const.Lead;
        dummy.meeting.model_id = this.id;
      }
      if (dummy.document) {
        dummy.document.model_no = Const.Lead;
        dummy.document.model_id = this.id;
      }
      if (dummy.email) {
        dummy.email.model_no = Const.Lead;
        dummy.email.model_id = this.id;
      }
      if (dummy.sms) {
        dummy.sms.model_no = Const.Lead;
        dummy.sms.model_id = this.id;
      }
      this.setState({ ...dummy });
      this.editLink = `${this.base}/add-edit/${this.id}`;
      this.iItem = 0;
      this.lItem = 0;
      LeadAPI.get(this.id, this.onReceived, this.onFail);
    }
  }

  componentDidMount() {
    if (this.id !== 0) {
      LeadAPI.get(this.id, this.onReceived, this.onFail);
    }
  }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = (res) => {
    this.lead = res;
    const SmsAdd = Util.isAllow(this.models.sms.permission, Const.PermAdd);
    const SmsOpt =
      this.lead && this.lead.sms_opt && this.lead.sms_opt === Const.True;
    this.SmsAdd = SmsAdd && !SmsOpt;

    const EmailOpt =
      this.lead && this.lead.email_opt && this.lead.email_opt === Const.True;
    const EmailAdd = Util.isAllow(this.models.email.permission, Const.PermAdd);
    this.EmailAdd = EmailAdd && !EmailOpt;

    this.setState({ ...this.state, inApiCall: false });
  };
  updateMater = () => {
    this.setState({ inApiCall: true, popup: null });
    LeadAPI.get(this.id, this.onReceived, this.onFail);
  };

  onUpdate = () => {
    this.setState({ ...this.state, inApiCall: true });
    LeadAPI.get(this.id, this.onReceived, this.onFail);
  };
  onDelete = () =>
    Util.confirmAlert(
      "Delete",
      `Are you sure you want to delete to ${Display.ModelName(this.lead)}`,
      "Delete",
      "No",
      () => {
        this.setState({ ...this.state, inApiCall: true });
        LeadAPI.delete(this.lead.id, this.onDeleteSuccess, this.onFail);
      }
    );
  onDeleteSuccess = () => {
    Util.showNotification("Successful", "Lead deleted successfully", "success");
    this.props.navigate("/lead");
  };

  onPrev = () => this.props.navigate(`/lead/next-prev/${this.iItem - 1}`);
  onNext = () => this.props.navigate(`/lead/next-prev/${this.iItem + 1}`);

  redirectAddContact = () =>
   this.props.navigate(`/contact/add-edit/${Const.Lead}/${this.id}/0`);
  addContact = (contact) => {
    this.setState({ inApiCall: true, popup: null });
    ContactAPI.addLeadContact(
      this.id,
      contact.value,
      this.onReceived,
      this.onFail
    );
  };
  onLoadContacts = (contacts) => {
    const options = contacts.map((contact) => {
      return { label: Display.Name(contact), value: contact.id };
    });
    this.setState({ ...this.state, contacts: options });
  };

  showPopUp = (model, field) => {
    if (field === LeadConst.SalesOrder) {
      this.props.navigate(`/sales-order/add-edit/1/${this.id}/0`);
      return;
    } else if (field === LeadConst.Quote) {
      this.props.navigate(`/quote/add-edit/1/${this.id}/${model}`);
      return;
    } else if (field === LeadConst.Service) {
      this.props.navigate(`/service/add-edit/1/${this.id}/${model}`);
      return;
    } else if (field === LeadConst.History) {
      this.props.navigate(`/lead/history/${this.id}`);
      return;
    } else if (field === LeadConst.Edit) {
      this.props.navigate(this.editLink);
      return;
    } else if (field === LeadConst.Delete) {
      this.onDelete();
      return;
    }
    let tmp = { ...this.state };
    tmp[field] = model;
    tmp.popup = field;
    this.setState({ ...tmp });
  };

  hidePopUp = () => this.setState({ ...this.state, popup: LeadConst.Refresh });

  showDetails = (model, field) => {
    if (field === LeadConst.SalesOrder) {
      this.props.navigate(`/sales-order/preview/${model}`);
      return;
    } else if (field === LeadConst.Quote) {
      this.props.navigate(`/quote/preview/${model}`);
      return;
    } else if (field === LeadConst.Contact) {
      this.props.navigate(`/contact/preview/${model}`);
      return;
    }
  };

  onDesignChange = (option) => {
    this.designOption = option;
    reactLocalStorage.set(Const.LeadTheme, option.value);
    this.props.onModuleChanged();
  };

  onPropertyCount = (count) => {
    this.setState({ propertyCount: count })
  }

  render() {
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        {!((this.lead?.responsible_person ?? '').includes(this.user?.user_id ?? 0)) && this.LeadPreviewRestrict ? (
          <RestrictedAccess />
        ) : (
          <div className="sectionprev pt-3">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-3">
                  <div className="row">
                    <div className="col-md-4">
                      <LeadScore isEnterprise={this.isEnterprise} lead={this.lead} fields={this.model.fields} />
                    </div>
                    <div className="col-md-8 alit">
                      {/*
                      <p><span className="lead-prev-btnlead"><span className="badge badge-success">Lead Score : 9</span></span></p>
                      */}
                      <h4>
                        <strong>{Display.ModelName(this.lead)}</strong>
                      </h4>
                      <p>
                        <strong>{this.model.fields.responsible_person.label_name} : </strong>
                        {Display.FieldValue(this.lead, "responsible_person", this.model.fields)}
                      </p>
                      {/*
                      <p>
                        <span className="buttons-social"><FaFacebook /></span>SalesAdd
                        <span className="buttons-social"><FaTwitter /></span>
                        <span className="buttons-social"><FaLinkedin /></span>
                      </p>
                    */}
                      <p className="d-flex flex-column">
                        <span className="lead-prev-btnlead">
                          <span className="badge badge-success">
                            {this.model.fields.progress.label_name} : {Display.FieldValue(this.lead, "progress", this.model.fields)}
                          </span>
                        </span>
                        <span className="lead-prev-btnlead">
                          <span className="badge badge-secondary mt-2">
                            {this.model.fields.property_count.label_name} : {this.state.propertyCount}
                          </span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <aside id="info-block">
                        <div className="file-marker">
                          <div>
                            <div className="box-title px-1 ml-1">Contact Information</div>
                            <div className="box-contents">
                              <div id="audit-trail">
                                <div className="p-2">
                                  <p>
                                    <strong>{this.model.fields.phone.label_name} : </strong>
                                    {Display.FieldValue(this.lead, "phone", this.model.fields)}
                                  </p>
                                  <p>
                                    <strong>{this.model.fields.email.label_name} : </strong>
                                    {Display.FieldValue(this.lead, "email", this.model.fields)}
                                  </p>
                                  <p>
                                    <strong>{this.model.fields.address.label_name} :</strong>
                                    {Display.FieldValue(this.lead, "address", this.model.fields)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </aside>
                    </div>
                  </div>
                </div>

                <div className="col-md-9">
                  <LeadPreviewPopUpList
                    popup={this.state.popup}
                    hidePopUp={this.hidePopUp}
                    updateMater={this.updateMater}
                    model={this.model}
                    module={Const.Lead}
                    id={this.id}
                    NoteAdd={this.NoteAdd}
                    CallAdd={this.CallAdd}
                    CallUpdate={this.CallUpdate}
                    call={this.state.call}
                    TaskAdd={this.TaskAdd}
                    TaskUpdate={this.TaskUpdate}
                    task={this.state.task}
                    TicketAdd={this.TicketAdd}
                    TicketUpdate={this.TicketUpdate}
                    ticket={this.state.ticket}
                    EmailAdd={this.EmailAdd}
                    MeetAdd={this.MeetAdd}
                    MeetUpdate={this.MeetUpdate}
                    meeting={this.state.meeting}
                    SmsAdd={this.SmsAdd}
                    DocAdd={this.DocAdd}
                    document={this.state.document}
                    ContactAdd={this.ContactAdd}
                    whatsAppAdd={this.whatsAppAdd}
                    contacts={this.state.contacts}
                    lead={this.lead}
                    note={this.state.note}
                    redirectAddContact={this.redirectAddContact}
                    addContact={this.addContact}
                    CloudCall={this.CloudCall}
                    CallCloudCall={this.state.CloudCall}
                    showPopUp={this.showPopUp}
                  />

                  <LeadPreviewActionList
                    lead={this.lead}
                    iItem={this.iItem}
                    lItem={this.lItem}
                    onPrev={this.onPrev}
                    onNext={this.onNext}
                    NoteAdd={this.NoteAdd}
                    CallAdd={this.CallAdd}
                    SeorviceAdd={this.ServiceAdd}
                    ServiceUpdate={this.ServiceUpdate}
                    TaskAdd={this.TaskAdd}
                    TicketAdd={this.TicketAdd}
                    MeetAdd={this.MeetAdd}
                    Property={this.Property}
                    DocAdd={this.DocAdd}
                    SmsAdd={this.SmsAdd}
                    EmailAdd={this.EmailAdd}
                    SalesAdd={this.SalesAdd}
                    QuoteAdd={this.QuoteAdd}
                    ContactAdd={this.ContactAdd}
                    CloudCall={this.CloudCall}
                    Update={this.Update}
                    Delete={this.Delete}
                    models={this.models}
                    property={this.onProperties}
                    showPopUp={this.showPopUp}
                    options={this.options}
                    option={this.designOption}
                    onDesignChange={this.onDesignChange}
                    type={LeadPreviewActionList.TypeActive}
                  />
                  <StatusProgressBar options={this.ProgressOptions} progress={this.lead ? this.lead['progress'] : 0} />

                  <TabPanelView
                    id={this.id}
                    type={Const.Lead}
                    reload={this.updateMater}
                    View={true}
                    lead={this.lead}
                    edit={this.showPopUp}
                    show={this.showDetails}
                    onLoad={this.onLoadContacts}
                    model={this.models}
                    cloud_call={this.CloudCall}
                    onCloudeCall={this.showPopUp}
                    onPropertyCount={this.onPropertyCount}
                  />
                </div>
              </div>
            </div>
          </div>
        )
      }
      </ApiUiController>
    );
  }
}
export default withRouter(LeadPreviewCompact);
